import React from "react";
import Home from "../pages/private/home";
import Admin from "../pages/private/admin";
import Locations from "../pages/private/locations";
import LocationDetail from "../pages/private/locations/locationdetail";
import TeamMembers from "../pages/private/teamMembers";
import Supervisors from "../pages/private/supervisors";
import Library from "../pages/private/library";
import Roles from "../pages/private/roles";
import Reports from "../pages/private/reports";
import SignIn from "../pages/public/SignIn";
import Register from "../pages/public/Register";
import RecoverPassword from "../pages/public/auth/RecoverPassword";
import ResetPassword from "../pages/public/auth/ResetPassword";
import AcceptInvite from "../pages/public/Invites";
import Contact from "../pages/public/auth/Contact";
import ModuleBuilder from "../pages/private/moduleBuilder";
import Streams from "../pages/private/streams";
import RoleDetails from "../pages/private/roles/detail";
import SupervisorsDetail from "../pages/private/supervisors/detail";
import TeamMemberDetail from "../pages/private/teamMembers/detail";
import StreamDetail from "../pages/private/streams/detail";
import Audience from "../pages/private/audience";
import AudienceDetail from "../pages/private/audience/detail";
import MarketPlace from "../pages/private/marketplace";
import ValidateEmail from "../pages/public/ValidateEmail";
import EngagedUsers from "../pages/private/engagedUsers";
import ModuleProgress from "../pages/private/reports/ModuleProgress";
import SingleCompanyBreakdown from "../pages/private/reports/vendorReports/SingleCompanyBreakdown";
import SingleLocationBreakdown from "../pages/private/reports/vendorReports/SingleLocationBreakdown";
import SingleUserBreakdown from "../pages/private/reports/vendorReports/SingleUserBreakdown";
import Referral from "../pages/public/Referral";
import EmailPreferences from "../pages/public/EmailPreferences";
import SingleStreamReport from "../pages/private/reports/vendorReports/SingleStreamReport";
import OrganizationReport from "../pages/private/reports/organization";

import {
  Home as HomeIcon,
  Monitor,
  Users,
  Layers,
  Book,
  Tag,
  TrendingUp,
  Cast,
  Globe,
  UserPlus,
  MapPin,
  BarChart,
  Box,
} from "react-feather";

export const PATHS = {
  SIGNIN: "/",
  REGISTER: "/register/",
  CONTACT: "/contact/",
  RECOVER_PASSWORD: "/recover-password/",
  VALIDATE_EMAIL: "/verify/:token/",
  RESET_PASSWORD: "/password-reset/:token/",
  ACCEPT_INVITE: "/invitation/:token/",
  HOME: "/home/",
  ADMIN: "/admin/",
  LOCATIONS: "/locations/",
  LOCATION_DETAIL: "/locations/detail/:id",
  TEAM_MEMBERS: "/teammembers/",
  TEAM_MEMBER_DETAIL: "/teammembers/detail/:id",
  SUPERVISORS: "/supervisors/",
  SUPERVISOR_DETAIL: "/supervisors/detail/:id",
  ROLES: "/roles/",
  ROLE_DETAIL: "/roles/details/:id",
  AUDIENCE: "/audience/",
  AUDIENCE_DETAIL: "/audience/detail/:id",
  LIBRARY: "/modules/",
  STREAMS: "/streams/",
  STREAM_DETAILS: "/streams/details/:id",
  MODULE_BUILDER: "/modules/quiz-builder/:id",
  MODULE_PROGRESS: "/modules/progress/:id",
  ENGAGED_USERS: "/engaged-users/",
  SINGLE_COMPANY_BREAKDOWN: "/vendor-reports/company/:id",
  SINGLE_LOCATION_BREAKDOWN: "/vendor-reports/location/:id",
  SINGLE_USER_BREAKDOWN: "/vendor-reports/user/:id",
  VENDOR_STREAM_REPORT: "/vendor-reports/stream/:id",
  REFERRAL: "/referral/:ref",
  EMAIL_PREFERENCES: ["/email-preferences/", "/email-preferences/:email"],
  REPORTS: "/reports/",
  ORGANIZATION_REPORT: "/organization/",
  MARKETPLACE: "/marketplace/",
};

const routes = [
  {
    path: PATHS.SIGNIN,
    component: SignIn,
    needsAuth: false,
    exact: true,
    allowManager: true,
    allowVendor: true,
    allowRetail: true,
    inSidebar: false,
  },
  {
    path: PATHS.REGISTER,
    component: Register,
    needsAuth: false,
    exact: false,
    allowManager: true,
    allowVendor: true,
    allowRetail: true,
    inSidebar: false,
  },
  {
    path: PATHS.CONTACT,
    component: Contact,
    needsAuth: false,
    exact: true,
    allowManager: true,
    allowVendor: true,
    allowRetail: true,
    inSidebar: false,
  },
  {
    path: PATHS.RECOVER_PASSWORD,
    component: RecoverPassword,
    needsAuth: false,
    exact: true,
    allowManager: true,
    allowVendor: true,
    allowRetail: true,
    inSidebar: false,
  },
  {
    path: PATHS.VALIDATE_EMAIL,
    component: ValidateEmail,
    needsAuth: false,
    exact: false,
    allowManager: true,
    allowVendor: true,
    allowRetail: true,
    inSidebar: false,
  },
  {
    path: PATHS.RESET_PASSWORD,
    component: ResetPassword,
    needsAuth: false,
    exact: false,
    allowManager: true,
    allowVendor: true,
    allowRetail: true,
    inSidebar: false,
  },
  {
    path: PATHS.ACCEPT_INVITE,
    component: AcceptInvite,
    needsAuth: false,
    exact: false,
    allowManager: true,
    allowVendor: true,
    allowRetail: true,
    inSidebar: false,
  },
  {
    path: PATHS.HOME,
    component: Home,
    needsAuth: true,
    id: "Home",
    exact: true,
    allowManager: true,
    allowVendor: true,
    allowRetail: true,
    inSidebar: true,
    icon: <HomeIcon />,
  },
  {
    id: "Admins",
    path: PATHS.ADMIN,
    component: Admin,
    needsAuth: true,
    exact: true,
    allowManager: false,
    allowVendor: true,
    allowRetail: true,
    icon: <Layers />,
    inSidebar: true,
  },
  {
    id: "Locations",
    path: PATHS.LOCATIONS,
    component: Locations,
    needsAuth: true,
    exact: true,
    allowManager: true,
    allowVendor: false,
    allowRetail: true,
    inSidebar: true,
    icon: <MapPin />,
  },
  {
    path: PATHS.LOCATION_DETAIL,
    component: LocationDetail,
    needsAuth: true,
    exact: false,
    allowManager: true,
    allowVendor: false,
    allowRetail: true,
    inSidebar: false,
  },
  {
    id: "Team Members",
    path: PATHS.TEAM_MEMBERS,
    component: TeamMembers,
    needsAuth: true,
    exact: true,
    allowManager: true,
    allowVendor: false,
    allowRetail: true,
    icon: <Users />,
    inSidebar: true,
  },
  {
    path: PATHS.TEAM_MEMBER_DETAIL,
    component: TeamMemberDetail,
    needsAuth: true,
    exact: false,
    allowManager: true,
    allowVendor: false,
    allowRetail: true,
    inSidebar: false,
  },
  {
    id: "Supervisors",
    path: PATHS.SUPERVISORS,
    component: Supervisors,
    needsAuth: true,
    exact: true,
    allowManager: false,
    allowVendor: false,
    allowRetail: true,
    icon: <Monitor />,
    inSidebar: true,
  },
  {
    path: PATHS.SUPERVISOR_DETAIL,
    component: SupervisorsDetail,
    needsAuth: true,
    exact: false,
    allowManager: false,
    allowVendor: false,
    allowRetail: true,
    inSidebar: false,
  },
  {
    id: "Roles",
    path: PATHS.ROLES,
    component: Roles,
    needsAuth: true,
    exact: true,
    allowManager: true,
    allowVendor: false,
    allowRetail: true,
    inSidebar: true,
    icon: <Tag />,
  },
  {
    path: PATHS.ROLE_DETAIL,
    component: RoleDetails,
    needsAuth: true,
    exact: true,
    allowManager: false,
    allowVendor: false,
    allowRetail: true,
    inSidebar: false,
  },
  {
    id: "Custom Audiences",
    path: PATHS.AUDIENCE,
    component: Audience,
    needsAuth: true,
    exact: true,
    allowManager: false,
    allowVendor: true,
    allowRetail: true,
    icon: <Cast />,
    inSidebar: true,
  },
  {
    path: PATHS.AUDIENCE_DETAIL,
    component: AudienceDetail,
    needsAuth: true,
    exact: true,
    allowManager: false,
    allowVendor: true,
    allowRetail: true,
    inSidebar: false,
  },
  {
    id: "Library",
    path: PATHS.LIBRARY,
    component: Library,
    needsAuth: true,
    exact: true,
    allowManager: true,
    allowVendor: true,
    allowRetail: true,
    icon: <Book />,
    inSidebar: true,
  },
  {
    id: "Streams",
    path: PATHS.STREAMS,
    component: Streams,
    needsAuth: true,
    exact: true,
    allowManager: false,
    allowVendor: true,
    allowRetail: true,
    inSidebar: true,
    icon: <TrendingUp />,
  },
  {
    path: PATHS.STREAM_DETAILS,
    component: StreamDetail,
    needsAuth: true,
    exact: true,
    allowManager: false,
    allowVendor: true,
    allowRetail: true,
    inSidebar: false,
  },
  {
    path: PATHS.MODULE_BUILDER,
    component: ModuleBuilder,
    needsAuth: true,
    exact: true,
    allowManager: true,
    allowVendor: true,
    allowRetail: true,
    inSidebar: false,
  },
  {
    path: PATHS.MODULE_PROGRESS,
    component: ModuleProgress,
    needsAuth: true,
    exact: true,
    allowManager: true,
    allowVendor: true,
    allowRetail: true,
    inSidebar: false,
  },

  {
    id: "Engaged Users",
    path: PATHS.ENGAGED_USERS,
    component: EngagedUsers,
    needsAuth: true,
    exact: true,
    allowManager: false,
    allowVendor: true,
    allowRetail: false,
    icon: <UserPlus />,
    inSidebar: true,
  },
  {
    path: PATHS.SINGLE_COMPANY_BREAKDOWN,
    component: SingleCompanyBreakdown,
    needsAuth: true,
    exact: true,
    allowManager: false,
    allowRetail: false,
    allowVendor: true,
    inSidebar: false,
  },
  {
    path: PATHS.SINGLE_LOCATION_BREAKDOWN,
    component: SingleLocationBreakdown,
    needsAuth: true,
    exact: true,
    allowManager: false,
    allowRetail: false,
    allowVendor: true,
    inSidebar: false,
  },
  {
    path: PATHS.SINGLE_USER_BREAKDOWN,
    component: SingleUserBreakdown,
    needsAuth: true,
    exact: true,
    allowManager: false,
    allowRetail: false,
    allowVendor: true,
    inSidebar: false,
  },
  {
    path: PATHS.VENDOR_STREAM_REPORT,
    component: SingleStreamReport,
    needsAuth: true,
    exact: true,
    allowManager: false,
    allowRetail: false,
    allowVendor: true,
    inSidebar: false,
  },
  {
    path: PATHS.REFERRAL,
    component: Referral,
    needsAuth: false,
    exact: false,
    allowManager: true,
    allowRetail: true,
    allowVendor: true,
    inSidebar: false,
  },
  {
    path: PATHS.EMAIL_PREFERENCES,
    component: EmailPreferences,
    needsAuth: false,
    exact: true,
    allowManager: true,
    allowRetail: true,
    allowVendor: true,
    inSidebar: false,
  },
  {
    id: "Reports",
    path: PATHS.REPORTS,
    component: Reports,
    needsAuth: true,
    exact: false,
    allowManager: true,
    allowVendor: true,
    allowRetail: true,
    inSidebar: true,
    icon: <BarChart />,
  },
  {
    id: "Organization Report",
    path: PATHS.ORGANIZATION_REPORT,
    component: OrganizationReport,
    needsAuth: true,
    exact: true,
    allowManager: false,
    allowVendor: false,
    allowRetail: true,
    inSidebar: true,
    icon: <Box />,
  },
  {
    id: "Marketplace",
    path: PATHS.MARKETPLACE,
    component: MarketPlace,
    needsAuth: true,
    exact: false,
    allowManager: true,
    allowVendor: false,
    allowRetail: true,
    icon: <Globe />,
    inSidebar: true,
  },
];

export default routes;
